export var PrivateLinkStatus;
(function (PrivateLinkStatus) {
    PrivateLinkStatus["PRIVATE_LINK_STATUS_CREATING"] = "CREATING";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_PENDING"] = "PENDING";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_PENDING_ACCEPTANCE"] = "PENDING_ACCEPTANCE";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_AVAILABLE"] = "AVAILABLE";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_DELETING"] = "DELETING";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_DELETED"] = "DELETED";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_REJECTED"] = "REJECTED";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_FAILED"] = "FAILED";
    PrivateLinkStatus["PRIVATE_LINK_STATUS_EXPIRED"] = "EXPIRED";
})(PrivateLinkStatus || (PrivateLinkStatus = {}));
